import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppUrlView from './AppUrlView'
import AppOauthView from './AppOauthView'
import AppExternalUrlView from './AppExternalUrlView'
import { fetchAppTestToken } from 'api/developerApi'
import ConditionalRender from 'components/ConditionalRender'
import { Loader } from '@driftt/tide-core'

import dividerSrc from '../divider.svg'
import './style.css'


class AppAuthView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isFetchingToken: false,
    hasErrored: false,
    token: ''
  }

  fetchToken = () => {
    const { appId } = this.props
    const onDone = (token) => this.setState({ token, hasSucceeded: true })
    const onError = (error) => {
      this.setState({ hasErrored: true })
      this.props.showErrorNotification('We couldn’t fetch your access token. Please refresh the page.')
    }
    const onFinally = () => this.setState({ isFetchingToken: false })

    const onStateSet = () => fetchAppTestToken(appId)
      .then(onDone)
      .catch(onError)
      .then(onFinally)

    this.setState({ isFetchingToken: true }, onStateSet)
  }

  componentDidMount() {
    this.fetchToken()
  }

  setToken = (token) => {
    this.setState({ token })
  }

  clearToken = () => {
    this.setState({ token: null })
  }

  render() {
    const { appId } = this.props
    const { isFetchingToken } = this.state

    return (
      <div className="app-auth-view">
        <div className="app-auth-view-page-title">
          Authorizing your App
        </div>
        <div className="app-auth-view-page-description">
          This page contains the urls that you can use for both authorizing users to connect your Drift app both internally and externally from the Drift platform.
          For more detail, see: <br /> <a
            href="https://devdocs.drift.com/docs/authentication-and-scopes"
            target="_blank"
            rel="noopener noreferrer">
            Authentication and Scopes
          </a>
        </div>
        <div>
          <ConditionalRender
            condition={!isFetchingToken}
            className="app-auth-testing-section">
            <AppOauthView appId={appId} sh />
          </ConditionalRender>
          <ConditionalRender
            condition={isFetchingToken}
            className="app-auth-view-loader">
            <Loader />
          </ConditionalRender>
        </div>
        <div>
        <ConditionalRender
            condition={!isFetchingToken}
            className="app-external-link">
            <AppExternalUrlView appId={appId}/>
          </ConditionalRender>
        </div>
        <img
          className="app-oauth-divider"
          src={dividerSrc}
          alt="divider"
        />
        <div>
          <ConditionalRender
            condition={!isFetchingToken}
            className="app-auth-testing-section">
            <AppUrlView appId={appId} />
          </ConditionalRender>
        </div>
      </div>
    )
  }
}

export default AppAuthView
